import React, { useRef } from "react";
import CustomButton from "custom/button/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import {
  hideCart,
  removeFromCart,
  selectCartItems,
  toggleCart,
} from "features/cart/cartSlice";
import { Link, useNavigate } from "react-router-dom";
import { useOutsideClick } from "custom/hooks";

export default function CartDropdown() {
  // const cartItems = useSelector((state) => state.cart.cartItems);
  const cartItems = useSelector(selectCartItems);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ref = useRef(null);
  useOutsideClick(ref, (e) => {
    e?.stopPropagation();
    dispatch(hideCart());
  });

  const handleProductDetailNavigate = ({ category, id, item }) => {
    navigate(`/shop/${category}/${id}`, {
      state: { item },
    });

    dispatch(hideCart());
  };

  const handleCheckout = () => {
    navigate("/checkout");
    dispatch(hideCart());
  };

  return (
    <div
      className="border-2 border-black rounded-3xl bg-white h-80 w-60 absolute right-0 top-16 z-10 p-5"
      ref={ref}
    >
      <div className="h-4/5 flex flex-col overflow-auto gap-3 mb-3">
        {cartItems.length ? (
          cartItems.map((item) => (
            <div key={item.id} className="flex justify-between">
              <div
                className="flex w-4/5 items-center gap-2 cursor-pointer"
                onClick={() =>
                  handleProductDetailNavigate({
                    category: item.category,
                    id: item.id,
                    item,
                  })
                }
              >
                <img
                  src={item.imageUrl}
                  alt="img"
                  className="w-1/3 h-12 rounded-xl object-cover"
                />
                <div className="flex flex-col">
                  <p className="text-sm font-bold">{item.name}</p>
                  <p className="text-sm">
                    {item.quantity} x{" "}
                    <span className="text-red-600">{item.price}₫</span>
                  </p>
                </div>
              </div>
              <button onClick={() => dispatch(removeFromCart(item.id))}>
                X
              </button>
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center w-full h-full">
            <h1 className="text-2xl font-bold text-slate-400">No products</h1>
          </div>
        )}
      </div>
      {cartItems.length > 0 && (
        // <Link to="/checkout">
        <CustomButton styles="mt-auto w-full px-3" onClick={handleCheckout}>
          GO TO CHECKOUT
        </CustomButton>
        // </Link>
      )}
    </div>
  );
}
